import { strCode } from "../localizations/strCode";
import deviceGroupNames from "./deviceGroupNames";

const firmwareDeviceTypes = [
  {
    id: "MERCURY_W_LCD_C",
    value: "MERCURY_W_LCD_C",
    types: [deviceGroupNames.charger],
    patchVersion: "1"
  },
  {
    id: "MERCURY_W_LB_C",
    value: "MERCURY_W_LB_C",
    types: [deviceGroupNames.charger],
    patchVersion: "2"
  },
  {
    id: "MERCURY_L_LCD_C",
    value: "MERCURY_L_LCD_C",
    types: [deviceGroupNames.charger],
    patchVersion: "3"
  },
  {
    id: "MERCURY_L_LB_C",
    value: "MERCURY_L_LB_C",
    types: [deviceGroupNames.charger],
    patchVersion: "4"
  }
];

export default firmwareDeviceTypes;

export const firmwareDeviceTypeOptions = [
  { id: 0, value: strCode.ALL_DEVICES_LABEL },
  ...firmwareDeviceTypes
];
